import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { NavLink, Outlet, useLocation, useNavigate } from "react-router-dom";
import SharePop from "../../components/common/shareLivestream";
import Modal from "../../components/Modal/Modal";
import { getCategoryRequest } from "../../store/shopping/shopping.actions";
import { getImage, getUserProfile } from "../../store/user/user.selector";
import PublicHall from "./PublicHall";

const ViewProfile = () => {
    const dispatch = useDispatch();
    const location = useLocation();
    const [uploadModal, setUploadModal] = useState(false);
    const [profileModal, setProfileModal] = useState(false);
    const scrollRef = useRef(null);
    const navigate = useNavigate();

    const scrollH = (e) => {
        e = window.event || e;
        let delta = Math.max(-1, Math.min(1, e.wheelDelta || -e.detail));
        scrollRef.current.scrollLeft -= delta * 40;
    };

    useEffect(() => {
        dispatch(getCategoryRequest());
    }, []);

    const { userProfile } = useSelector((state) => {
        return {
            userProfile: getUserProfile(state),
        };
    });

    const shareUrl = process.env.REACT_APP_URL + "/" + userProfile.userName;
    return (
        <div className=" h-full overflow-hidden">
            <div className="flex h-full">
                <div className="w-full md:flex-1 my-2 sm:my-4 mx-2 sm:mx-4 md:mx-8 bg-white rounded-lg max-h-full flex flex-col">
                    <div className="">
                        <div className="bg-orange-color px-2 sm:px-5 pt-3 sm:pt-4 rounded-tl-lg rounded-tr-lg">
                            {/* <div className="flex justify-end pr-5 md:pr-10">
                                <svg
                                    onClick={() => setUploadModal(true)}
                                    width="20"
                                    height="19"
                                    viewBox="0 0 20 19"
                                    className="cursor-pointer stroke-current text-white"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M8.5 3.07422H3.5C2.39543 3.07422 1.5 3.96965 1.5 5.07422V16.0742C1.5 17.1788 2.39543 18.0742 3.5 18.0742H14.5C15.6046 18.0742 16.5 17.1788 16.5 16.0742V11.0742M15.0858 1.66001C15.8668 0.878957 17.1332 0.878957 17.9142 1.66001C18.6953 2.44105 18.6953 3.70738 17.9142 4.48843L9.32842 13.0742H6.5L6.5 10.2458L15.0858 1.66001Z"
                                        strokeWidth="1.5"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                </svg>
                            </div> */}
                            <div className="px-3.5 py-2.5 bg-white rounded-2xl flex gap-x-3 md:gap-x-10 relative -bottom-[52px] z-10 profile-shadow mr-2 sm:mr-4 md:mr-0">
                                <div className="grid grid-cols-3 items-center md:grid-cols-5 flex-1">
                                    <div className="ml-auto md:m-0 shrink-0 col-span-2">
                                        <div className="flex items-center">
                                            <img
                                                src={getImage(
                                                    userProfile.avatar
                                                        .attachments
                                                )}
                                                className="w-20 h-20 rounded-full mb-1.5"
                                                alt=""
                                            />
                                            <div className="relative pl-4">
                                                {userProfile.role === "Pro" && (
                                                    <button className="absolute p-2 py-1 text-sm font-bold text-white bg-orange-color block rounded-lg right-[-50px] top-[-5px]">
                                                        Pro
                                                    </button>
                                                )}
                                                <h3 className="text-sm font-medium text-ebony-color">
                                                    {userProfile.fullName}
                                                </h3>
                                                <p className="text-sm text-ebony-color/70">
                                                    @{userProfile.userName}
                                                </p>
                                                <div className="py-1 px-2 bg-[#F7F0FF] rounded-md flex gap-x-2 mb-1 w-fit">
                                                    <span>
                                                        <svg
                                                            width="11"
                                                            height="11"
                                                            viewBox="0 0 11 11"
                                                            fill="none"
                                                            xmlns="http://www.w3.org/2000/svg"
                                                        >
                                                            <path
                                                                d="M8.35577 8.40265C8.03598 8.72244 7.47788 9.28054 6.94148 9.81694C6.16043 10.598 4.89428 10.598 4.11323 9.81696C3.58758 9.29131 3.03731 8.74104 2.69892 8.40265C1.13682 6.84055 1.13682 4.30789 2.69892 2.74579C4.26101 1.18369 6.79367 1.18369 8.35577 2.74579C9.91787 4.30789 9.91787 6.84055 8.35577 8.40265Z"
                                                                stroke="#7900F8"
                                                                strokeWidth="1.15535"
                                                                strokeLinecap="round"
                                                                strokeLinejoin="round"
                                                            />
                                                            <path
                                                                d="M7.02734 5.57422C7.02734 6.40265 6.35577 7.07422 5.52734 7.07422C4.69892 7.07422 4.02734 6.40265 4.02734 5.57422C4.02734 4.74579 4.69892 4.07422 5.52734 4.07422C6.35577 4.07422 7.02734 4.74579 7.02734 5.57422Z"
                                                                stroke="#7900F8"
                                                                strokeWidth="1.15535"
                                                                strokeLinecap="round"
                                                                strokeLinejoin="round"
                                                            />
                                                        </svg>
                                                    </span>
                                                    <p className="text-extraSmall text-black-80 font-medium">
                                                        {
                                                            userProfile.country
                                                                .isoCode
                                                        }
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div
                                        className="text-center"
                                        onClick={() =>
                                            navigate(
                                                "/page/profile/list#follower"
                                            )
                                        }
                                    >
                                        <p className="text-xl font-bold text-ebony-color">
                                            {userProfile.countFollower}
                                        </p>
                                        <p className="text-sm font-normal text-black-50">
                                            Followers
                                        </p>
                                    </div>
                                    <div
                                        className="text-center"
                                        onClick={() =>
                                            navigate(
                                                "/page/profile/list#following"
                                            )
                                        }
                                    >
                                        <p className="text-xl font-bold text-ebony-color">
                                            {userProfile.countFollowing}
                                        </p>
                                        <p className="text-sm font-normal text-black-50">
                                            Following
                                        </p>
                                    </div>
                                    <div
                                        className="text-center"
                                        onClick={() =>
                                            navigate(
                                                "/page/profile/list#subscriber"
                                            )
                                        }
                                    >
                                        <p className="text-xl font-bold text-ebony-color">
                                            {userProfile.countSubscriber}
                                        </p>
                                        <p className="text-sm font-normal text-black-50">
                                            Subscribers
                                        </p>
                                    </div>
                                </div>
                                {/* <div className="flex justify-end items-start pt-2.5 md:pr-6">
                                    <svg
                                        onClick={() =>
                                            navigate("/page/account")
                                        }
                                        width="20"
                                        height="19"
                                        viewBox="0 0 20 19"
                                        className="stroke-current text-orange-color cursor-pointer"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M8.5 3.07422H3.5C2.39543 3.07422 1.5 3.96965 1.5 5.07422V16.0742C1.5 17.1788 2.39543 18.0742 3.5 18.0742H14.5C15.6046 18.0742 16.5 17.1788 16.5 16.0742V11.0742M15.0858 1.66001C15.8668 0.878957 17.1332 0.878957 17.9142 1.66001C18.6953 2.44105 18.6953 3.70738 17.9142 4.48843L9.32842 13.0742H6.5L6.5 10.2458L15.0858 1.66001Z"
                                            strokeWidth="1.5"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                    </svg>
                                </div> */}
                            </div>
                        </div>
                    </div>

                    <div className="p-4 overflow-y-auto bg-white flex-grow">
                        <div className="px-4 pt-20 mb-[17px] pl-5">
                            <p className="text-sm text-black-60 text-left">
                                {userProfile.descriptions}
                            </p>
                            <div className="flex justify-end items-start">
                                <span>
                                    <svg
                                        onClick={() => setProfileModal(true)}
                                        width="25"
                                        height="7"
                                        className="cursor-pointer"
                                        viewBox="0 0 25 7"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <circle
                                            cx="3.5"
                                            cy="3.07422"
                                            r="3"
                                            fill="black"
                                            fillOpacity="0.2"
                                        />
                                        <circle
                                            cx="12.5"
                                            cy="3.07422"
                                            r="3"
                                            fill="black"
                                            fillOpacity="0.2"
                                        />
                                        <circle
                                            cx="21.5"
                                            cy="3.07422"
                                            r="3"
                                            fill="black"
                                            fillOpacity="0.2"
                                        />
                                    </svg>
                                </span>
                            </div>
                        </div>
                        <div className="px-4 bg-white shrink-0">
                            <div
                                onWheel={(e) => scrollH(e)}
                                ref={scrollRef}
                                className="w-full overflow-scroll no-scrollbar"
                            >
                                <ul
                                    className={`w-full flex items-center space-x-2 pb-[5px] border-b border-black-10`}
                                >
                                    <li>
                                        <NavLink
                                            to="/page/profile/public-hall"
                                            className={`text-sm font-medium text-black-60 hover:text-orange-color pb-[7px] hover:border-b-2 border-orange-color capitalize px-5 view-profile-nav whitespace-nowrap ${
                                                location.pathname ==
                                                "/page/profile"
                                                    ? "active"
                                                    : ""
                                            }`}
                                        >
                                            Public Hall
                                        </NavLink>
                                    </li>
                                    <li>
                                        <NavLink
                                            to="/page/profile/private-lounge"
                                            className="text-sm font-medium text-black-60 hover:text-orange-color pb-[7px] hover:border-b-2 border-orange-color capitalize px-5 view-profile-nav whitespace-nowrap"
                                        >
                                            Private Lounge
                                        </NavLink>
                                    </li>
                                    {/* <li>
                                        <NavLink
                                            to="/page/profile/meeting-room"
                                            className="text-sm font-medium text-black-60 hover:text-orange-color pb-[7px] hover:border-b-2 border-orange-color capitalize px-5 view-profile-nav whitespace-nowrap"
                                        >
                                            Meeting Room
                                        </NavLink>
                                    </li> */}
                                    {/* <li>
                                        <NavLink
                                            to="/page/profile/vip-circle"
                                            className="text-sm font-medium text-black-60 hover:text-orange-color pb-[7px] hover:border-b-2 border-orange-color capitalize px-5 view-profile-nav whitespace-nowrap"
                                        >
                                            VIP Circle
                                        </NavLink>
                                    </li> */}
                                    <li>
                                        <NavLink
                                            to="/page/profile/recordings"
                                            className="text-sm font-medium text-black-60 hover:text-orange-color pb-[7px] hover:border-b-2 border-orange-color capitalize px-5 view-profile-nav whitespace-nowrap"
                                        >
                                            My Recordings
                                        </NavLink>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="pt-4">
                            {location.pathname.indexOf("profile") > -1 ? (
                                <Outlet />
                            ) : (
                                <PublicHall />
                            )}
                        </div>
                    </div>
                </div>

                <div
                    className={`w-[300px] bg-white px-4 overflow-y-auto overflow-hidden  hidden lg:block`}
                >
                    <div className="h-full flex flex-col justify-between">
                        <div className="">
                            <div className="mb-[22px]">
                                <div className=" flex flex-col items-center mt-6 mb-5">
                                    <img
                                        src={getImage(
                                            userProfile.avatar.attachments
                                        )}
                                        className="w-[108px] h-[108px] rounded-full mb-1.5"
                                        alt=""
                                    />
                                    <div className="text-center relative">
                                        {userProfile.role === "Pro" && (
                                            <button className="absolute p-2 py-1 text-sm font-bold text-white bg-orange-color block rounded-lg right-[-50px] top-[-5px]">
                                                Pro
                                            </button>
                                        )}
                                        <h5 className="text-sm text-ebony-color font-medium mb-px">
                                            {userProfile.fullName}
                                        </h5>
                                        <p className="text-sm text-black-70">
                                            @{userProfile.userName}
                                        </p>
                                    </div>
                                </div>
                                <div className="flex justify-between px-4 mb-[22px]">
                                    <div
                                        className="text-center cursor-pointer"
                                        onClick={() =>
                                            navigate(
                                                "/page/profile/list#follower"
                                            )
                                        }
                                    >
                                        <span className="text-lg mb-0.5 font-bold text-ebony-color">
                                            {userProfile.countFollower}
                                        </span>
                                        <p className="text-sm text-black-50">
                                            Followers
                                        </p>
                                    </div>
                                    <div
                                        className="text-center cursor-pointer"
                                        onClick={() =>
                                            navigate(
                                                "/page/profile/list#following"
                                            )
                                        }
                                    >
                                        <span className="text-lg mb-0.5 font-bold text-ebony-color">
                                            {userProfile.countFollowing}
                                        </span>
                                        <p className="text-sm text-black-50">
                                            Following
                                        </p>
                                    </div>
                                    <div
                                        className="text-center cursor-pointer"
                                        onClick={() =>
                                            navigate(
                                                "/page/profile/list#subscriber"
                                            )
                                        }
                                    >
                                        <span className="text-lg mb-0.5 font-bold text-ebony-color">
                                            {userProfile.countSubscriber}
                                        </span>
                                        <p className="text-sm text-black-50">
                                            Subscribers
                                        </p>
                                    </div>
                                </div>
                                <div className="">
                                    <button
                                        onClick={() =>
                                            navigate("/page/start-new-video")
                                        }
                                        className="text-sm font-bold text-white py-2.5 bg-orange-color w-full block rounded-lg "
                                    >
                                        Start new video
                                    </button>
                                </div>
                            </div>

                            {/* Profile nav  */}
                            <ul className="flex flex-col gap-y-1">
                                <li>
                                    <NavLink
                                        to="/page/profile"
                                        className="flex items-center py-2 px-[9px] hover:bg-purple-color/5 rounded-10 text-black-50 hover:text-ebony-color profile-nav"
                                    >
                                        <div className="mr-4 p-2 bg-black-5 rounded-md">
                                            <svg
                                                width="16"
                                                height="16"
                                                className="text-black-50 hover:text-purple-color fill-current profile-nav-icon"
                                                viewBox="0 0 16 16"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path d="M1.75 15.5C1.75 15.5 0.5 15.5 0.5 14.25C0.5 13 1.75 9.25 8 9.25C14.25 9.25 15.5 13 15.5 14.25C15.5 15.5 14.25 15.5 14.25 15.5H1.75ZM8 8C8.99456 8 9.94839 7.60491 10.6517 6.90165C11.3549 6.19839 11.75 5.24456 11.75 4.25C11.75 3.25544 11.3549 2.30161 10.6517 1.59835C9.94839 0.895088 8.99456 0.5 8 0.5C7.00544 0.5 6.05161 0.895088 5.34835 1.59835C4.64509 2.30161 4.25 3.25544 4.25 4.25C4.25 5.24456 4.64509 6.19839 5.34835 6.90165C6.05161 7.60491 7.00544 8 8 8Z" />
                                            </svg>
                                        </div>
                                        <span className="capitalize text-sm font-medium">
                                            View profile
                                        </span>
                                    </NavLink>
                                </li>
                                <li>
                                    <NavLink
                                        to="/page/account"
                                        className="flex items-center py-2 px-[9px] hover:bg-purple-color/5 rounded-10 text-black-50 hover:text-ebony-color profile-nav"
                                    >
                                        <div className="mr-4 p-2 bg-black-5 rounded-md">
                                            <svg
                                                width="17"
                                                height="19"
                                                className="text-black-50 hover:text-purple-color fill-current profile-nav-icon"
                                                viewBox="0 0 17 19"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path d="M2.33366 8.3335V14.1668H4.83366V8.3335H2.33366ZM7.33366 8.3335V14.1668H9.83366V8.3335H7.33366ZM0.666992 18.3335H16.5003V15.8335H0.666992V18.3335ZM12.3337 8.3335V14.1668H14.8337V8.3335H12.3337ZM8.58366 0.833496L0.666992 5.00016V6.66683H16.5003V5.00016L8.58366 0.833496Z" />
                                            </svg>
                                        </div>
                                        <span className="capitalize text-sm font-medium">
                                            Account & preferences
                                        </span>
                                    </NavLink>
                                </li>
                                {/* <li>
                                    <NavLink
                                        to="/vf"
                                        className="flex items-center py-2 px-[9px] hover:bg-purple-color/5 rounded-10 text-black-50 hover:text-ebony-color profile-nav"
                                    >
                                        <div className="mr-4 p-2 bg-black-5 rounded-md">
                                            <svg
                                                width="16"
                                                height="16"
                                                className="text-black-50 hover:text-purple-color fill-current profile-nav-icon"
                                                viewBox="0 0 16 16"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path d="M8 15.4998C5.90278 15.4998 4.12833 14.774 2.67667 13.3223C1.22556 11.8712 0.5 10.0971 0.5 7.99984C0.5 6.08317 1.125 4.41984 2.375 3.00984C3.625 1.60039 5.22222 0.777615 7.16667 0.541504C7.51389 0.499837 7.78472 0.624837 7.97917 0.916504C8.17361 1.20817 8.16667 1.51373 7.95833 1.83317C7.72222 2.19428 7.545 2.57623 7.42667 2.979C7.30889 3.38178 7.25 3.80539 7.25 4.24984C7.25 5.49984 7.6875 6.56234 8.5625 7.43734C9.4375 8.31234 10.5 8.74984 11.75 8.74984C12.1806 8.74984 12.6078 8.68734 13.0317 8.56234C13.455 8.43734 13.8333 8.26373 14.1667 8.0415C14.4583 7.84706 14.7569 7.8365 15.0625 8.00984C15.3681 8.18373 15.5 8.45817 15.4583 8.83317C15.2639 10.7498 14.4481 12.3401 13.0108 13.604C11.5731 14.8679 9.90278 15.4998 8 15.4998Z" />
                                            </svg>
                                        </div>
                                        <span className="capitalize text-sm font-medium">
                                            Dark mode
                                        </span>
                                    </NavLink>
                                </li> */}
                                <li>
                                    <NavLink
                                        to="/a"
                                        className="flex items-center py-2 px-[9px] hover:bg-purple-color/5 rounded-10 text-black-50 hover:text-ebony-color"
                                    >
                                        <div className="mr-4 p-2 bg-black-5 rounded-md">
                                            <svg
                                                width="16"
                                                height="16"
                                                viewBox="0 0 16 16"
                                                className="text-black-50 hover:text-purple-color fill-current profile-nav-icon"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path d="M15.3203 8.44531L12.0391 11.7266C11.9191 11.8412 11.7597 11.9055 11.5938 11.9062C11.5133 11.9065 11.4336 11.8905 11.3594 11.8594C11.2442 11.8128 11.1455 11.7329 11.0759 11.6299C11.0063 11.5269 10.969 11.4055 10.9688 11.2812V8.625H6.125C5.95924 8.625 5.80027 8.55915 5.68306 8.44194C5.56585 8.32473 5.5 8.16576 5.5 8C5.5 7.83424 5.56585 7.67527 5.68306 7.55806C5.80027 7.44085 5.95924 7.375 6.125 7.375H10.9688V4.71875C10.969 4.59447 11.0063 4.47308 11.0759 4.37011C11.1455 4.26713 11.2442 4.18723 11.3594 4.14062C11.4735 4.0953 11.5982 4.08372 11.7187 4.10727C11.8392 4.13082 11.9504 4.18849 12.0391 4.27344L15.3203 7.55469C15.4377 7.67318 15.5035 7.83322 15.5035 8C15.5035 8.16678 15.4377 8.32682 15.3203 8.44531ZM6.125 14.25H1.75V1.75H6.125C6.29076 1.75 6.44973 1.68415 6.56694 1.56694C6.68415 1.44973 6.75 1.29076 6.75 1.125C6.75 0.95924 6.68415 0.800269 6.56694 0.683058C6.44973 0.565848 6.29076 0.5 6.125 0.5H1.75C1.41848 0.5 1.10054 0.631696 0.866116 0.866116C0.631696 1.10054 0.5 1.41848 0.5 1.75V14.25C0.5 14.5815 0.631696 14.8995 0.866116 15.1339C1.10054 15.3683 1.41848 15.5 1.75 15.5H6.125C6.29076 15.5 6.44973 15.4342 6.56694 15.3169C6.68415 15.1997 6.75 15.0408 6.75 14.875C6.75 14.7092 6.68415 14.5503 6.56694 14.4331C6.44973 14.3158 6.29076 14.25 6.125 14.25Z" />
                                            </svg>
                                        </div>
                                        <span className="capitalize text-sm font-medium">
                                            Sign out
                                        </span>
                                    </NavLink>
                                </li>
                            </ul>
                        </div>

                        <div className="pt-1 pb-4 border-t border-black-10 text-center mt-28">
                            <p className="text-sm font-medium text-black-30">
                                &copy; 2022 Ulalive Inc
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            {/* Upload Modal  */}
            <Modal show={uploadModal} onClose={() => setUploadModal(false)}>
                <div className="w-full xs:w-[360px]">
                    <div className="mb-2.5">
                        <h3 className="text-base font-bold text-ebony-color">
                            Upload banner
                        </h3>
                    </div>

                    <div className="rounded-md border border-black-10 py-11 cursor-pointer flex justify-center items-center text-black-10 hover:text-orange-color mb-2.5">
                        <svg
                            width="31"
                            height="31"
                            className="stroke-current"
                            viewBox="0 0 31 31"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M15.4993 0.916016C23.5537 0.916016 30.0827 7.44497 30.0827 15.4993C30.0827 23.5537 23.5537 30.0827 15.4993 30.0827C7.44497 30.0827 0.916016 23.5537 0.916016 15.4993C0.916016 7.44497 7.44497 0.916016 15.4993 0.916016ZM15.4993 8.20768C15.235 8.20769 14.9797 8.30341 14.7805 8.47713C14.5813 8.65086 14.4518 8.89083 14.4158 9.15268L14.4056 9.30143V14.4056H9.30143C9.02431 14.4057 8.75756 14.511 8.55507 14.7001C8.35258 14.8893 8.22945 15.1483 8.21056 15.4248C8.19167 15.7013 8.27843 15.9746 8.45331 16.1896C8.62819 16.4045 8.87815 16.5451 9.15268 16.5829L9.30143 16.5931H14.4056V21.6973C14.4057 21.9744 14.511 22.2411 14.7001 22.4436C14.8893 22.6461 15.1483 22.7692 15.4248 22.7881C15.7013 22.807 15.9746 22.7203 16.1896 22.5454C16.4045 22.3705 16.5451 22.1205 16.5829 21.846L16.5931 21.6973V16.5931H21.6973C21.9744 16.593 22.2411 16.4877 22.4436 16.2986C22.6461 16.1094 22.7692 15.8504 22.7881 15.5739C22.807 15.2974 22.7203 15.0241 22.5454 14.8091C22.3705 14.5942 22.1205 14.4536 21.846 14.4158L21.6973 14.4056H16.5931V9.30143C16.5931 9.01135 16.4779 8.73315 16.2727 8.52803C16.0676 8.32292 15.7894 8.20768 15.4993 8.20768Z"
                                fill="black"
                                fillOpacity="0.1"
                            />
                        </svg>
                    </div>

                    <div className="">
                        <p className="text-sm font-medium text-orange-color mb-8">
                            *Required ratio 1:5.7{" "}
                        </p>
                        <div className="flex items-center gap-3">
                            <button
                                onClick={() => setUploadModal(false)}
                                type="submit"
                                className="py-2.5 px-5 text-sm rounded-lg capitalize border border-orange-color bg-orange-color font-bold text-white"
                            >
                                save
                            </button>
                            {userProfile.phone && userProfile.email && (
                                <button
                                    onClick={() => setUploadModal(false)}
                                    className="py-2.5 px-5 text-sm rounded-lg capitalize border border-black-10 bg-white font-medium text-black-50"
                                >
                                    cancel
                                </button>
                            )}
                        </div>
                    </div>
                </div>
            </Modal>

            {/* Share Profile Modal  */}
            <Modal show={profileModal} onClose={() => setProfileModal(false)}>
                <SharePop
                    onClose={() => setProfileModal(false)}
                    shareUrl={shareUrl}
                    title={userProfile.fullName}
                    subTitle={userProfile.userName}
                    image={getImage(userProfile.avatar.attachments)}
                    heading="Share Profile"
                />
            </Modal>
        </div>
    );
};

export default ViewProfile;
